/**
* @file 搜索组件
* @description 搜索组件，处理商品搜索和分页展示功能，支持表格和卡片两种视图切换
* @author zhouyang
* @date 2026-06-09
* @version 1.0.0
* @copyright 脱手网物联科技(南京)有限公司
*/
<template>
	<div>
		<HeadIndex v-on:HeadIndexSearch="HeadIndexSearch($event)"></HeadIndex>
		<el-row>
			<el-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 24, offset: 0 }" :md="{ span: 22, offset: 1 }"
				:lg="{ span: 22, offset: 1 }" :xl="{ span: 18, offset: 3 }" class="custom-col-20 offset-col-2">
				<div class="">
					<el-row class="">
						<el-col :span="24" class="">
							<div>
								<div class="view-switch">
									<el-icon @click="switchView('index2')"
										:class="['switch-icon', { active: currentView === 'index2' }]" size="20">
										<Grid />
									</el-icon>
									<el-icon @click="switchView('table')"
										:class="['switch-icon', { active: currentView === 'table' }]" size="20">
										<List />
									</el-icon>

								</div>
								<div ref="height_top">
									<component :is="currentView === 'table' ? 'TableComponent' : 'Index2Component'"
							ref="childComponent" :tableData="tableData" :loading="loading"
							:user_id="user_id" :tableHeight="tableHeight" :filter="filter" :showCart="showCart" @update-cart-count="updateCartCount" />
								</div>

							</div>
						</el-col>
						<el-col :span="24" ref='pagination' style="display: flex; justify-content: flex-end;">
							<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page"
								background :page-size="parseInt(page_size)" prev-text="上一页" next-text="下一页"
								layout="prev,pager, next" @current-change="handleCurrentChange" :total="total">
							</el-pagination>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
		<ShoppingCart ref="floatingSidebar" v-if="showCart" />
	</div>
</template>
<script>
import { ElMessage } from 'element-plus'
import { Grid, List } from '@element-plus/icons-vue'
import HeadIndex from '../public/HeadIndex';
import TableComponent from './table.vue';
import Index2Component from './index2.vue';
import ShoppingCart from '../public/shoppingCart .vue';
export default {
	name: 'search',
	components: {
		HeadIndex,
		TableComponent,
		Index2Component,
		Grid,
		List,
		ShoppingCart,
	},
	data() {

		return {
			total: 0,
			page: 1,
			page_size: 20,
			filter: '',
			stock_type: '',
			user_id: '',
			currentView: 'index2',
			loading: false,
			tableData: [],
			tableHeight: 500,
			showCart: false,
			stock_type_list: [
				{ text: '滞纳、在保、包附完好', value: '滞纳、在保、包附完好' },
				{ text: '滞纳、在保、包附破损', value: '滞纳、在保、包附破损' },
				{ text: '滞纳、过保、包附完好', value: '滞纳、过保、包附完好' },
				{ text: '滞纳、过保、包附破损', value: '滞纳、过保、包附破损' },
				{ text: '二手、在保、包附完好', value: '二手、在保、包附完好' },
				{ text: '二手、在保、包附破损', value: '二手、在保、包附破损' },
				{ text: '二手、过保、包附完好', value: '二手、过保、包附完好' },
				{ text: '二手、过保、包附破损', value: '二手、过保、包附破损' },
			],
		}
	},
	props: [],

	updated() {

	},

	watch: {
		filter(val, newval) { }
	},
	mounted() {
		this.tableHeight_fun();
	},

	activated() {

	},
	created() {
		this.user_id = localStorage.getItem('user_id');
		this.filter = this.$route.query.filter
		this.stock_type = this.$route.query.stock_type
		const savedView = localStorage.getItem('search_view');
		this.currentView = savedView || 'index2';
		this.search();
	},

	methods: {
		/**
		 * 切换视图组件
		 * @param {string} view - 视图名称 ('table' 或 'index2')
		 */
		switchView(view) {
			this.currentView = view;
			localStorage.setItem('search_view', view);
		},
		HeadIndexSearch(val) {
			this.filter = val.filter
			this.stock_type = val.stock_type
			this.page = 1;
			this.search();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		async search() {
			if (this.loading) {
				return false;
			}
			this.loading = true;

			const stockTypeStr = this.stock_type || '';
			const stockTypeArr =stockTypeStr? stockTypeStr.split(','):[];

			let stock_type = '';
			let img_infoArr = [];
			let brand_name = [];
			let img_info = '';
			let order_no_associate_arr = [];
			let model_associate_arr = [];
			let order_no_associate = '';
			let model_associate = '';
			let verify_status_arr = [];
			if (stockTypeArr.length > 0) {
				stockTypeArr.forEach(item => {
					const trimItem = item.trim();
					if (trimItem === '1' || trimItem === '2') {
						img_infoArr.push(trimItem);
					} else if (trimItem === '3' || trimItem === '4') {
						order_no_associate_arr.push(trimItem);
					} else if (trimItem === '5' || trimItem === '8') {
						model_associate_arr.push(trimItem);
					} else if (trimItem === '9' || trimItem === '10') {
						verify_status_arr.push(trimItem);
					} else if (this.stock_type_list.some(st => st.value === trimItem || st.text === trimItem)) {
						console.log(item);
						stock_type = stock_type ? `${stock_type},${trimItem}` : trimItem;
					} else{
						brand_name.push(trimItem);
					}
				});

				img_info = img_infoArr.join(',');
				if(verify_status_arr.length === 2){
					verify_status_arr = '';
				}else if(verify_status_arr.length === 1){
					verify_status_arr = verify_status_arr[0];
				}
				if (order_no_associate_arr.length === 2) {
					order_no_associate = '';
				} else if (order_no_associate_arr.length === 1) {
					order_no_associate = order_no_associate_arr[0];
				}

				if (model_associate_arr.length === 2) {
					model_associate = '';
				} else if (model_associate_arr.length === 1) {
					model_associate = model_associate_arr[0];
				}
			}

			var search = {
				page: this.page,
				ps: this.page_size,
				filter: this.filter,
				stock_type: stock_type,
				img_info: img_info,
				order_no_associate: order_no_associate,
				model_associate: model_associate,
				brand_name: brand_name,
				verify_status: verify_status_arr,
			};

			await this.$axios.post('/api/yunsys.Storage/getstorage', search) //'' /api/yunsys.Storage/getteststorage
				.then(async (res) => {
					var res = res.data;
					this.loading = false;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true
						});
					}
					var obj = this;
					this.total = 99999999999;
					res.data.forEach(item => {
						item.stock_type_txt_list = item.stock_type_txt.split("、");
						item.num_input = 1;
						if (obj.user_id) {
							item.real_money = obj.$bn.multiply(item.sur_num, item.real_price, 2);
							item.real_price = obj.$bn.multiply(item.real_price, 1, 2);
							item.tsw_price = obj.$bn.multiply(item.tsw_price, 1, 2);
							item.tsw_discount = obj.$bn.divide(item.tsw_price, item.price, 3);
						} else {
							item.real_money = '*';
							item.real_price = '*';
							item.discount_calculate = '*';
							item.sur_num = '*';
						}
					});
					this.tableData = res.data;
				})
				.catch(err => {
					console.log(err);
					this.loading = false;
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true
					});
				});
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 80
			})
		},
		updateCartCount(item) {
			this.$axios.post('/api/yunsys.Cart/add', {
				id: item.id,
				num: item.num_input
			}).then(res => {
				var res = res.data;
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true
					});
				}
				if (this.$refs.floatingSidebar) {
					this.$refs.floatingSidebar.updateCartCount(item.num_input)
				}
				ElMessage({
					message: '加入购物车成功',
					type: 'success',
					grouping: true
				});
			}).catch(err => {
				console.log(err);
				return ElMessage({
					message: '系统错误',
					type: 'error',
					grouping: true
				});
			});
		},
	}
}
</script>
<style lang="less" scoped>
:deep(.el-pager .number) {
	display: none
}

:deep(.el-pager .more) {
	display: none
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
	background-color: #ff8a5c;
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}

.logo_m {
	margin: 5px 0px 5px 0px;
	height: auto;
}

.view-switch {
	display: flex;
	gap: 10px;
	margin-bottom: 15px;
}

.switch-icon {
	cursor: pointer;
	color: #909399;
	transition: color 0.3s;

	&:hover {
		color: #ff8a5c;
	}

	&.active {
		color: #ff8a5c;
	}
}
</style>
